define('model/CartModel',['require','lib/model/BaseModel'],function (require) {

	var BaseModel = require('lib/model/BaseModel');

	/**
	 * Cart module model
	 * 
	 * @class CartModel
	 */
	return BaseModel.extend({
		
		_items: [],

		addItem: function (item) {
			this._items.push(item);
			this.listenTo(item, 'sync', this.trigger.bind(this, 'sync'));
			this.listenTo(item, 'change', this.trigger.bind(this, 'change'));
			this.listenTo(item, 'add:item', this.trigger.bind(this, 'add:item'));
			this.listenTo(item, 'toggle:popup', this.trigger.bind(this, 'toggle:popup'));
		},

		getQty: function () {
			return this._items.map(function (item) {
				return item.getQty()
			}).reduce(function (a, b) {
				return a + b;
			}, 0);
		},

		getTax: function () {
			return this._items.map(function (item) {
				return item.getTax()
			}).reduce(function (a, b) {
				return a + b;
			}, 0);
		},

		getTotal: function () {
			return this._items.map(function (item) {
				return item.getTotal()
			}).reduce(function (a, b) {
				return a + b;
			}, 0);
		},

		getCurrency: function () {
			// assume all items have same currency
			var currency = null;
			this._items.forEach(function (item) {
				var itemCurrency = item.getCurrency();

				if (itemCurrency) {
					currency = itemCurrency;
				}
			});

			return currency;
		},

		hasItems: function () {
			return this._items.length > 0;
		},

		triggerCheckout: function () {	
			var productsItem = this._items.find(function(item) { return item.get('key') === 'product'; });
			var multipleBookingItem = this._items.find(function(item) { return item.get('key') === 'multiple_booking'; });

			if (productsItem && productsItem.getQty() > 0) {
				if (multipleBookingItem && multipleBookingItem.getQty() > 0) {
					multipleBookingItem.set('products', productsItem.get('items'));
					multipleBookingItem.trigger('checkout');
				} else {
					productsItem.trigger('checkout');
				}
			} else if (multipleBookingItem && multipleBookingItem.getQty() > 0) {
				multipleBookingItem.trigger('checkout');
			} else {
				// how could this happpen?
			}
		},

		triggerAfterCheckout: function () {
			this._items.forEach(function (item) {
				item.trigger('after:checkout');
			});
		},

		getServiceIds: function () {
			return this._items.map(function (item) {
				return item.getServiceIds();
			}).reduce(function (a, b) {
				return a.concat(b);
			}, []);
		},

		getProductIds: function () {
			return this._items.map(function (item) {
				return item.getProductIds();
			}).reduce(function (a, b) {
				return a.concat(b);
			}, []);
		}
        
	});
	
});
